// @flow
import React, { useState } from 'react'
import Switcher from './Switcher'
import styled from 'styled-components'
import type { Node } from 'react'

const TabsWrapper = styled.div`
  padding-top: 30px;
`

type Props = {|
  tabs: Array<{| title: string, html?: string, renderer?: Node |}>
|}

export default function Tabs(props: Props) {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0)
  const tab = props.tabs[activeTabIndex]

  return (
    <div>
      <Switcher
        options={props.tabs.map((tab, index) => ({ id: index.toString(), name: tab.title }))}
        value={activeTabIndex.toString()}
        onChange={(val) => setActiveTabIndex(parseInt(val))}
      />
      <TabsWrapper>
        {tab.html ? <div dangerouslySetInnerHTML={{ __html: tab.html }} /> : tab.renderer}
      </TabsWrapper>
    </div>
  )
}
